import removeValue from './removeValue';

// @param {Function} test Accepts value to test, returns true if matches or false if doesn't.
const removeValueMatching = (arr, test) => {
  const value = arr.find(test);

  return removeValue(arr, value);
};

export default removeValueMatching;